import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { LocalDataSource } from 'angular2-smart-table';
import { EventService, IEvent, IEventSepa, IEventStand } from '../../services/database/event/event.service';
import { PricelistService } from '../../services/database/event/pricelist.service';
import { ImageService } from '../../services/media/image.service';
import { ToastrService } from '../../services/toastr/toastr.service';
import { DatePipe } from '@angular/common';
import { DownloadLinkComponent } from '../../components/download-link/download-link.component';

@Component({
  selector: 'ngx-eventdetails',
  templateUrl: './eventdetails.component.html',
  styleUrls: ['./eventdetails.component.scss'],
  providers: [DatePipe]
})
export class EventdetailsComponent implements OnInit {
  event: IEvent;
  loading = false;
  eventDetailForm: FormGroup;
  eventStandForm: FormGroup;
  imgFile: string;
  imgCouponFile: string;
  imgBannerFile: string;
  imageChanged = false;
  imageCouponChanged = false;
  imageBannerChanged = false;
  eventId: string;
  logoURL: string;
  couponURL: string;
  bannerURL: string;
  source: LocalDataSource = new LocalDataSource();
  sepaSource: LocalDataSource = new LocalDataSource();
  showEventStand = false;
  selectedEventStand = null;
  category_data = [];
  latitude: number;
  longitude: number;
  zoom: number;
  address: string;
  private geoCoder;
  showBusinessDetails = false;
  sendMails = false;


  @ViewChild('search')
  public searchElementRef: ElementRef;


  settings = {
    mode: 'external',
    hideHeader: false,
    actions: {
      add: true,
      edit: true,
      delete: true,
      position: 'right'
    },
    confirmSave: true,
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>'
    },
    add: {
      addButtonContent: '<i class="nb-plus-circled"></i>'
    },
    columns: {
      key: {
        editable: false,
        title: 'ID',
        show: false
      },
      name: {
        title: 'Name',
        type: 'string',
      },
      categories_string: {
        editable: false,
        title: 'Categories'
      }
    }
  }

  sepaSettings = {
    mode: 'external',
    hideHeader: false,
    actions: {
      add: false,
      edit: false,
      delete: true,
      visible: true,
      position: 'right'
    },
    confirmDelete: true,
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
      confirmDelete: true,
    },
    columns: {
      key: {
        editable: false,
        title: 'ID',
        show: true
      },
      date_generated: {
        title: 'Date',
        type: 'timestamp',
        editable: false
      },
      file: {
        title: 'File',
        filter: false,
        type: 'string',
        show: false
      },
      download: {
        title: 'Download',
        type: 'custom',
        renderComponent: DownloadLinkComponent,
        filter: false
      },
      status: {
        type: 'string',
        filter: false,
        show: false,
        title: 'Status',
        visible: false
      }
    }
  }

  constructor(
    private eventService: EventService,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private route: ActivatedRoute,
    private imageService: ImageService,
    private pricelistService: PricelistService,
    private ngZone: NgZone,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.eventId = this.route.snapshot.paramMap.get('eventId');
    // Change this when we have a parameter to define a "heuro" alike app
    if(this.eventId == 'CUOQNkBXBymv8joIHGXK') {
      this.showBusinessDetails = true;
      this.settings.columns['address'] = {
        editable: false,
        title: 'Address'
      };
      this.settings.columns['email'] = {
        editable: false,
        title: 'E-mail'
      };
      this.settings.columns['vat_nr'] = {
        editable: false,
        title: 'VAT nr'
      };
      this.settings.columns['bankaccount'] = {
        editable: false,
        title: 'Bank'
      };
      this.settings.columns['telephone_nr'] = {
        editable: false,
        title: 'Phone'
      };
      this.settings.columns['client_id'] = {
        editable: false,
        title: 'Client ID'
      };
    }
    this.pricelistService.getCategory(this.eventId).subscribe((categories) => {
      this.category_data = [];
      categories.forEach((category) => {
        this.category_data.push({
          name: category.name,
          key: category.key,
        })
      })
    })
    this.eventDetailForm = this.formBuilder.group({
      name: ['', Validators.required],
      description: ['', Validators.required],
      file: [''],
      logo: [''],
      couponFile: [''],
      couponLogo: [''],
      bannerFile: [''],
      bannerLogo: [''],
      lat: [''],
      lng: [''],
      startDate: [null],
      endDate: [null],
      couponPrice: [0],
      minimumAmountOfCoupons: [0],
      allowRefund: false,
      allowRefundToCharity: false,
      allowRefundToMyAccount: false,
      showEventHostDetails: false,
      hostName: [''],
      hostCompany: [''],
      hostPhone: [''],
      hostEmail: [''],
      hostAddress: [''],
      minimumAmountForFreeTransaction: [0],
      transactionFee: [0],
      payNLAPIToken: [''],
      payNLServiceId: [''],
      payconiqAPIKey: [''],
      payconiqMerchantId: [''],
      payconiqMerchantURL: [''],
      payconiqProfileId: ['']
    });
    this.eventStandForm = this.formBuilder.group({
      eventStandName: ['', Validators.required],
      categories: []
    });
    this.eventService.getEvent(this.eventId).subscribe(event => {
      this.event = event;
      this.logoURL = event.logoURL;
      this.couponURL = event.couponURL;
      this.bannerURL = event.bannerURL;
      this.latitude = this.event._geoloc?.lat;
      this.longitude = this.event._geoloc?.lng;
      this.zoom = 12;
      //this.getAddress(this.latitude, this.longitude);
      this.eventDetailForm = this.formBuilder.group({
        name: [this.event.name, Validators.required],
        description: [this.event.description, Validators.required],
        file: [''],
        logo: [''],
        couponFile: [''],
        couponLogo: [''],
        bannerFile: [''],
        bannerLogo: [''],
        lat: [this.event._geoloc?.lat, Validators.required],
        lng: [this.event._geoloc?.lng, Validators.required],
        startDate: [this.event.startDate?.toDate(), Validators.required],
        endDate: [this.event.endDate?.toDate(), Validators.required],
        couponPrice: [this.event.couponPrice, Validators.required],
        minimumAmountOfCoupons: [this.event.minimumAmountOfCoupons, Validators.required],
        allowRefund: [this.event.allowRefund],
        allowRefundToCharity: [this.event.allowRefundToCharity],
        allowRefundToMyAccount: [this.event.allowRefundToMyAccount],
        showEventHostDetails: [this.event.showEventHostDetails],
        hostName: [this.event.hostName],
        hostCompany: [this.event.hostCompany],
        hostPhone: [this.event.hostPhone],
        hostEmail: [this.event.hostEmail],
        hostAddress: [this.event.hostAddress],
        minimumAmountForFreeTransaction: [this.event.minimumAmountForFreeTransaction],
        transactionFee: [this.event.transactionFee],
        payNLAPIToken: [this.event.payNLAPIToken],
        payNLServiceId: [this.event.payNLServiceId],
        payconiqAPIKey: [this.event.payconiqAPIKey],
        payconiqMerchantId: [this.event.payconiqMerchantId],
        payconiqMerchantURL: [this.event.payconiqMerchantURL],
        payconiqProfileId: [this.event.payconiqProfileId]
      });
      this.loading = false;
    });

    this.eventService.getEventStands(this.eventId).subscribe((pricelist_items) => {
      const data = [];
      pricelist_items.forEach((stand: IEventStand) => {
        data.push({
          name: stand.name,
          categories_string: stand.categories_string,
          key: stand.key,
          address: stand.address,
          email: stand.email,
          vat_nr: stand.vat_nr,
          bankaccount: stand.bankaccount,
          telephone_nr: stand.telephone_nr,
          client_id: stand.client_id
        })
      })
      this.source.load(data);
    })

    this.eventService.getEventSepa(this.eventId).subscribe((sepa_items) => {
      const data = [];
      sepa_items.forEach((sepa: IEventSepa) => {
        let formattedDate = '...';
        if(sepa.date_generated) {
          const genarated_date = sepa.date_generated.toDate();
          formattedDate = this.datePipe.transform(genarated_date, 'dd/MM/yyyy HH:mm'); // Format the date
        }
        data.push({
          date_generated: formattedDate,
          key: sepa.key,
          status: sepa.status,
          file: sepa.status == 'error' ? 'No transactions' : this.eventId + '/' + sepa.file
        });
      })
      this.sepaSource.load(data);
    })
    //load Places Autocomplete
    /*
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder;

      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.getAddress(this.latitude, this.longitude);
          this.e.lat.setValue(this.latitude);
          this.e.lng.setValue(this.longitude);
          this.zoom = 12;
        });
      });
    });
    */
  }

  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 8;
        this.getAddress(this.latitude, this.longitude);
      });
    }
  }

  markerDragEnd($event: any) {
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
    this.e.lat.setValue(this.latitude);
    this.e.lng.setValue(this.longitude);
    this.getAddress(this.latitude, this.longitude);
  }

  getAddress(latitude, longitude) {
    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      if (status === 'OK') {
        if (results[0]) {
          this.zoom = 12;
          this.address = results[0].formatted_address;
        } else {
          window.alert('No results found');
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }

    });
  }

  onImageChange(e) {
    const reader = new FileReader();
    this.imageChanged = true;
    let height;
    if(e.target.files && e.target.files.length) {
      const [file] = e.target.files;
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.imgFile = reader.result as string;
        this.eventDetailForm.patchValue({
          logo: reader.result
        });

      };
    }
  }

  onCouponChange(e) {
    const reader = new FileReader();
    this.imageCouponChanged = true;
    let height;
    if(e.target.files && e.target.files.length) {
      const [file] = e.target.files;
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.imgCouponFile = reader.result as string;
        this.eventDetailForm.patchValue({
          couponLogo: reader.result
        });
      };
    }
  }

  onBannerChange(e) {
    const reader = new FileReader();
    this.imageBannerChanged = true;
    let height;
    if(e.target.files && e.target.files.length) {
      const [file] = e.target.files;
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.imgBannerFile = reader.result as string;
        this.eventDetailForm.patchValue({
          bannerLogo: reader.result
        });
      };
    }
  }

  initEventStand() {
    this.eventStandForm = this.formBuilder.group({
      eventStandName: ['', Validators.required],
      categories: [],
      eventStandAddress: [''],
      eventStandEmail: [''],
      eventStandVatNr: [''],
      eventStandBankAccount: [''],
      eventStandPhoneNr: [''],
      eventStandClientId: ['']
    });
  }

  onEdit(event) {
    this.eventService.getEventStand(this.eventId, event.data.key).then((stand) => {
      this.selectedEventStand = event.data.key;
      this.eventStandForm = this.formBuilder.group({
        eventStandName: [stand.data().name, Validators.required],
        categories: [stand.data().categories],
        eventStandAddress: [stand.data().address],
        eventStandEmail: [stand.data().email],
        eventStandVatNr: [stand.data().vat_nr],
        eventStandBankAccount: [stand.data().bankaccount],
        eventStandPhoneNr: [stand.data().telephone_nr],
        eventStandClientId: [stand.data().client_id]
      });
      this.showEventStand = true;
    })
  }

  onCancel() {
    this.showEventStand = false;
    this.selectedEventStand = null;
  }

  onCreate() {
    this.initEventStand();
    this.showEventStand = true;
  }

  onDelete(event) {
    this.eventService.deleteEventstand(this.eventId, event.data.key)
  }

  onDeleteSepa(event) {
    this.eventService.deleteSepa(this.eventId, event.data.key)
  }


  get e() { return this.eventDetailForm.controls; }

  get s() { return this.eventStandForm.controls; }

  onSubmitEventStand() {
    if (this.eventStandForm.invalid) {
      this.toastrService.show('Form incomplete', 'Please provide all required fields', 'warning');
      return;
    };

    this.eventService.updateEventstand(this.eventId, this.selectedEventStand, {
      name: this.s.eventStandName.value,
      categories: this.s.categories.value,
      address: this.s.eventStandAddress.value,
      email: this.s.eventStandEmail.value,
      vat_nr: this.s.eventStandVatNr.value,
      bankaccount: this.s.eventStandBankAccount.value,
      telephone_nr: this.s.eventStandPhoneNr.value,
      client_id: this.s.eventStandClientId.value,
    }).then(() => {
      this.showEventStand = false;
      this.selectedEventStand = null;
    })


  }

  onSubmit() {
    if (this.eventDetailForm.invalid) {
      this.toastrService.show('Form incomplete', 'Please provide all required fields', 'warning');
      return;
    };

    if(this.imageBannerChanged) {
      this.imageService.uploadBanner(this.e.bannerLogo.value, this.eventId).then((uploadTaskBanner) => {
        uploadTaskBanner.ref.getDownloadURL().then((bannerURL) => {
          this.updateEvent(null, null, bannerURL)})
      })
    }


    if(this.imageChanged) {
      this.imageService.uploadLogo(this.e.logo.value, this.eventId).then((uploadTask) => {
        uploadTask.ref.getDownloadURL().then((url) => {
          if(this.imageCouponChanged) {
            this.imageService.uploadCoupon(this.e.couponLogo.value, this.eventId).then((uploadTaskCoupon) => {
              uploadTaskCoupon.ref.getDownloadURL().then((couponURL) => {this.updateEvent(url, couponURL)})
            })
          } else {
            this.updateEvent(url);
          }
        })
      }, (error) => {
        this.toastrService.show(
          'Error',
          `Error: ${error}`,
          'danger');
      })
    }
    else {
      if(this.imageCouponChanged) {
        this.imageService.uploadCoupon(this.e.couponLogo.value, this.eventId).then((uploadTaskCoupon) => {
          uploadTaskCoupon.ref.getDownloadURL().then((couponURL) => {this.updateEvent(null, couponURL)})
        })
      } else {
        this.updateEvent();
      }
    }
  }

  deactivateUsers() {
    this.eventService.deactivateEventUsers(this.eventId);
  }


  changeSendMails()
  {
    this.sendMails = !this.sendMails;
  }

  generateSepa() {
    return this.eventService.generateSepa(this.eventId, this.sendMails);
  }

  updateEvent(logoURL?: string, couponURL?: string, bannerURL?: string) {
    return this.eventService.updateEvent({
      key: this.event.key,
      name: this.e.name.value,
      description: this.e.description.value,
      logoURL: logoURL ? logoURL : this.logoURL,
      couponURL: couponURL ? couponURL : this.couponURL ? this.couponURL : null,
      bannerURL: bannerURL ? bannerURL : this.bannerURL ? this.bannerURL : null,
      _geoloc: {
        lat: this.e.lat.value,
        lng: this.e.lng.value,
      },
      startDateObj: this.e.startDate.value,
      endDateObj: this.e.endDate.value,
      couponPrice: this.e.couponPrice.value,
      minimumAmountOfCoupons: this.e.minimumAmountOfCoupons.value,
      allowRefund: this.e.allowRefund.value,
      allowRefundToCharity: this.e.allowRefundToCharity.value,
      allowRefundToMyAccount: this.e.allowRefundToMyAccount.value,
      showEventHostDetails: this.e.showEventHostDetails.value,
      hostName: this.e.hostName.value,
      hostCompany: this.e.hostCompany.value,
      hostPhone: this.e.hostPhone.value,
      hostEmail: this.e.hostEmail.value,
      hostAddress: this.e.hostAddress.value,
      minimumAmountForFreeTransaction: this.e.minimumAmountForFreeTransaction.value,
      transactionFee: this.e.transactionFee.value,
      payNLAPIToken: this.e.payNLAPIToken.value,
      payNLServiceId: this.e.payNLServiceId.value,
      payconiqAPIKey: this.e.payconiqAPIKey.value,
      payconiqMerchantId: this.e.payconiqMerchantId.value,
      payconiqMerchantURL: this.e.payconiqMerchantURL.value,
      payconiqProfileId: this.e.payconiqProfileId.value
    })
    .then((success) => {
      this.toastrService.show(
        `Success`,
        `Event successfully updated..`,
        'success');
      this.loading = false;
    }, (error) => {
      this.toastrService.show(
        'Error',
        `Error: ${error}`,
        'danger');
      this.loading = false;
    });
  }

}
